import { register } from '../component.js';
import 'react';

var _socialIcons_developer = register("developer.mozilla", {"color":"#236ab4","path":"M27.69 12.93 15.85 51.07H11l11.8-38.14h4.89Zm4.31 0v38.14h-4.31V12.93H32Zm16.69 0-11.8 38.15h-4.85l11.81-38.15h4.85Zm4.31 0v38.14h-4.31V12.93H53Z"});

export { _socialIcons_developer as default };
